/**
 * Which recommender (if any) a product card element belongs to.
 *
 * Shared by the click events (listing-click-analytics.js trackClick) and the
 * add-to-cart handlers, so a click and the confirmed add that follows report
 * the same recommender / recommenderName.
 */

/**
 * Recommender title for an element already known to sit in a recommender.
 * SearchSpring block h3 -> BC carousel data-list-name -> first PDP section heading.
 */
export function getRecommenderName(el) {
    const ssTitle = el.closest('[id^="ss__recommendation--"]')?.querySelector('h3')?.textContent?.trim();
    const carouselName = el.closest('.productCarousel')?.getAttribute('data-list-name')?.trim();
    const pageHeading = document.querySelector('h2.productView-title')?.textContent?.trim();
    return ssTitle || carouselName || pageHeading || null;
}

/**
 * Which Quick Add by SKU form: slide-out cart drawer, cart page, or listing sidebar.
 */
function getQuickAddPlacement(form) {
    if (form.closest('#cart-preview-dropdown')) return 'cart_drawer';
    if (form.closest('.cart-sku-add')) return 'cart_page';
    if (form.closest('#side-cart-container')) return 'sidebar';
    return null;
}

/**
 * { recommender, recommenderName } for an element inside Recommended Accessories,
 * a SearchSpring recommendation, or a BC product carousel; null otherwise.
 * A Quick Add by SKU form also gets the placement of the form it came from.
 */
export function getRecommenderContext(el) {
    const quickAddForm = el.closest('form.js-quick-add');
    if (quickAddForm) {
        return {
            recommender: 'quick_add_sku',
            recommenderName: 'Quick Add by SKU',
            placement: getQuickAddPlacement(quickAddForm),
        };
    }
    if (el.closest('#recommended_accessories')) {
        return { recommender: 'accessories', recommenderName: 'Recommended Accessories' };
    }
    if (el.closest('[id^="ss__recommendation--"]') || el.closest('.productCarousel')) {
        return { recommender: 'recommender', recommenderName: getRecommenderName(el) };
    }
    return null;
}
